<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">
                {{
                  $t(
                    type == "my"
                      ? "message.menu.my-orders"
                      : "message.menu.orders",
                  )
                }}
              </h4>
            </div>
            <div class="card-body px-3">
              <ContractsFilter
                :label="$t('message.contracts.filter_contracts')"
                @input="applyFilter"
              ></ContractsFilter>
              <br />
              <b-tabs pills content-class="mt-3" small v-model="current_tab">
                <b-tab
                  v-for="(group, index) in contract_groups"
                  :key="'btab-' + index"
                  :title="group_labels[index]"
                  lazy
                >
                <div class="table-responsive-mobile">
                  <b-table
                    id="orders-table"
                    responsive
                    :items="group.contracts"
                    :fields="fields"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @row-clicked="open_contract"
                  >
                    <template v-slot:cell()="data">
                      <router-link
                        class="text-dark"
                        :to="{
                          name: 'contracts-single',
                          params: { id: data.item.id },
                        }"
                        >{{ data.value }}</router-link
                      >
                    </template>
                    <template
                      v-slot:cell(attis_contract_contragent_name)="data"
                    >
                      <span v-if="data.value != '-10'">{{ data.value }}</span>
                    </template>

                    <template v-slot:cell(remove)="data">
                      <button
                        class="btn btn-sm btn-link text-danger"
                        @click="removeContract(data)"
                        v-if="can_remove(data)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </template>
                  </b-table>
                </div>
                  <div class="d-flex justify-content-center">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="group.contracts.length"
                      :per-page="perPage"
                      aria-controls="orders-table"
                    ></b-pagination>
                  </div>
                </b-tab>
                <b-tab
                  :title="$t('message.contracts.new')"
                  @click="gotoNew"
                  title-item-class="ml-md-auto"
                  id="add-new-contract"
                  title-link-class="btn-outline-success btn-sm btn mt-2 mt-lg-0 rounded p-2"
                ></b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var querystring = require("querystring");
var ifvisible = require("ifvisible.js");
import { required } from "vuelidate/lib/validators";
import ContractsFilter from "./contracts-filter.vue";
export default {
  components: {
    ContractsFilter,
  },
  data() {
    return {
      type: "all",

      current_tab: 0,
      just_loaded: false,
      perPage: 10,
      currentPage: 0,
      contract_groups: [],
      add_product: false,
      product_error: false,
      loading: false,
      list: [],
      cleave: {
        numeral: true,
      },
      fields: [
        {
          key: "attis_contract_number",
          label: this.$t("message.contracts.number"),
          sortable: true,
        },
        {
          key: "attis_contract_date",
          label: this.$t("message.contracts.date"),
          sortable: true,
        },
        {
          key: "owner_org_name",
          label: this.$t("message.contracts.owner"),
          sortable: true,
        },
        {
          key: "attis_contract_contragent_name",
          label: this.$t("message.contracts.contragent"),
          sortable: true,
        },

        {
          key: "attis_contract_subject",
          label: this.$t("message.contracts.title"),
          sortable: true,
        },
        {
          key: "attis_contract_amount",
          label: this.$t("message.contracts.amount"),
          sortable: true,
        },
        {
          key: "attis_contract_currency",
          label: this.$t("message.contracts.currency"),
          sortable: true,
        },

        {
          key: "remove",
          label: "",
          sortable: false,
          tdClass: "text-right",
        },
      ],
      product_fields: [
        {
          key: "title",
          label: this.$t("message.find_partner.product_title"),
          sortable: true,
        },
        {
          key: "sku",
          label: this.$t("message.find_partner.product_sku"),
          sortable: true,
        },
        // {
        // 	key: 'ved',
        // 	label: this.$t('message.find_partner.product_ved'),
        // 	sortable: true
        // },
        {
          key: "qty",
          label: this.$t("message.find_partner.product_qty"),
          sortable: true,
        },
        // {
        // 	key: 'units',
        // 	label: this.$t('message.find_partner.product_units'),
        // 	sortable: true
        // },
        {
          key: "unit_price",
          label: this.$t("message.find_partner.product_unit_price"),
          sortable: true,
        },
        {
          key: "remove",
          label: "",
          tdClass: "text-right",
        },
      ],
      form_error: false,
      companies_tmp: "",
      companys: [],
      product: {
        title: "",
        sku: "",
        qty: "",
        ved: "",
        units: "",
        unit_price: "",
      },
      products: [],
      details: {
        seller: "",
        public: false,
        conditions: "",
        term: "",
      },
      group_labels: [
        this.$t("message.contracts.contract_group_new"),
        this.$t("message.contracts.contract_group_mine"),
        this.$t("message.contracts.contract_group_participate"),
      ],
    };
  },
  methods: {
    open_contract(item) {
      this.$router.push({ name: "contracts-single", params: { id: item.id } });
    },
    applyFilter(data) {
      console.log(data);
      this.$root.$emit("filter-contracts", { filter: data });
    },
    gotoNew() {
      this.$router.push({ name: "contracts-add" });
    },
    stringifyProducts() {
      var result = [];
      this.products.forEach((product) => {
        var line = "";
        line = "product[title][]=" + product.title;
        line += "&product[sku][]=" + product.sku;
        line += "&product[ved][]=" + product.ved;
        line += "&product[qty][]=" + product.qty;
        line += "&product[units][]=" + product.units;
        line += "&product[unit_price][]=" + product.unit_price;
        result.push(line);
      });
      return result.join("&");
    },
    submit() {
      this.$v.$touch();
      if (this.$v.details.$invalid) {
        this.form_error = true;
        setTimeout(() => {
          $("html,body").animate(
            { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
            1000,
          );
        }, 100);
      } else {
        this.form_error = false;
        this.loading = true;
        axios
          .post(
            window.base + "/contract/add",
            querystring.stringify(this.details) +
              "&" +
              this.stringifyProducts(),
          )
          .then((response) => {
            // console.log(response.data)
            // alert(response.data.statusMessage)
            this.load();
            this.loading = false;
          })
          .catch((error) => {
            console.error(error);
            alert("Contract " + error);
            this.loading = false;
          });
      }
      // axios({
      // 	method: 'post',
      // 	url: '/account/register',
      // 	data: bodyFormData,
      // 	headers: {'Content-Type': 'multipart/form-data' }
      // }).then(response=>{
      // 	console.log(response.data)
      // 	alert(response.data.statusMessage)
      // })
    },
    removeProduct(index) {
      this.products.splice(index, 1);
    },
    addProduct() {
      // this.hideAddProduct()
      this.$v.$touch("product");
      if (this.$v.product.$invalid) {
        this.product_error = true;
        setTimeout(() => {
          $("html,body").animate(
            { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
            1000,
          );
        }, 100);
      } else {
        this.product_error = false;
        this.hideAddProduct();
        this.products.push({
          title: this.product.title,
          sku: this.product.sku,
          qty: this.product.qty,
          ved: this.product.ved,
          units: this.product.units,
          unit_price: this.product.unit_price,
        });
        this.product = {
          title: "",
          sku: "",
          qty: "",
          ved: "",
          units: "",
          unit_price: "",
        };
      }
    },
    showAddProduct() {
      this.add_product = true;
    },
    hideAddProduct() {
      this.add_product = false;
    },
    getLibrary(type, query) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=10" +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.$data[type + (type[type.length - 1] == "s" ? "es" : "s")] =
            response.data;
        });
    },
    load(f = "") {
      axios
        .get(
          window.base +
            "/contract?customer_id=" +
            this.$store.state.user.id +
            (this.type == "my" ? "&my=1" : "") +
            "&filter=" +
            f,
        )
        .then((response) => {
          this.contract_groups = response.data;
          this.current_tab = 0;
          this.just_loaded = true;
          setTimeout(() => {
            this.current_tab = 0;
          }, 200);
          setTimeout(() => {
            this.current_tab = 0;
            setTimeout(() => {
              this.current_tab = 0;
            }, 500);
          }, 500);
        });
    },
    can_remove(data) {
      if (data.item.attis_contract_owner == this.user_id) return true;
      return false;
    },
    removeContract(data) {
      this.$bvModal
        .msgBoxConfirm(this.$t("message.contracts.confirm_removal"), {
          title: this.$t("message.confirm"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("message.yes"),
          cancelTitle: this.$t("message.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            axios
              .post(window.base + "/contract/delete?id=" + data.item.id)
              .then((r) => {
                this.load();
              });
          }
        })
        .catch((err) => {
          this.load();
        });
    },
  },
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    document.addEventListener("visibilitychange", (evt) => {
      if (ifvisible.now()) {
        if (this.just_loaded) {
          this.just_loaded = false;
          setTimeout(() => {
            this.current_tab = 0;
          }, 200);
        }
      }
    });
    if (!this.$store.state.auth) {
      this.$router.push({ name: "sign-in" });
    } else {
      if (this.$route.name == "contracts-mine") this.type = "my";
      this.load();
      this.$root.$on("filter-contracts", (p) => {
        console.log(p);
        this.load(p.filter);
      });
      this.$root.$on("reload-contracts", () => {
        this.load();
      });
    }
  },
  computed: {
    user_id() {
      return this.$store.state.user.id;
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  watch: {
    companies_tmp: _.debounce(function (query) {
      this.getLibrary("company", query);
    }, 500),
    $route() {
      this.load();
    },
    contract_groups() {
      this.current_tab = 0;
      setTimeout(() => {
        this.current_tab = 0;
      }, 400);
    },
  },
  validations: {
    details: {
      seller: {
        required,
      },
      conditions: {
        required,
      },
      term: {
        required,
      },
      public: {
        required,
      },
    },
    product: {
      title: {
        required,
      },
      sku: {
        required,
      },
      qty: {
        required,
      },
      ved: {
        required,
      },
      units: {
        required,
      },
      unit_price: {
        required,
      },
    },
  },
};
</script>
<style scoped>
@media (max-width: 768px) {
  .table-responsive-mobile {
    width: 100%;
    overflow-x: auto;
    min-width: 700px;
    -webkit-overflow-scrolling: touch;
  }
  .tab-pane {
    overflow-x: auto;
  }
    /* Deep selector to target child components */
    ::v-deep .card .tabs .nav-link {
    margin-right: 10px !important;
  }
}
</style>